export function hasValue(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function hasStringValue(str: string | null | undefined): boolean {
  return hasValue(str) && str !== '';
}

export function hasNumericValue(str: any): boolean {
  return hasValue(str) && !isNaN(str);
}

export function nullToString(value: any): string {
  return hasValue(value) ? value : '';
}
